import React from 'react';
import LegalPageLayout, { Section, SubSection, Paragraph, List } from './LegalPageLayout';

const TermsOfService = () => {
  return (
    <LegalPageLayout title="Terms of Service" lastUpdated="November 11, 2025">
      {/* Agreement to Terms */}
      <Section title="1. Agreement to Terms">
        <Paragraph>
          By accessing or using DIZEE ("Service," "Platform," "we," "us," or "our"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, you may not access or use the Service.
        </Paragraph>
        <Paragraph>
          We reserve the right to modify these Terms at any time. Your continued use of the Service after changes are posted constitutes acceptance of the modified Terms.
        </Paragraph>
      </Section>

      {/* Use of Service */}
      <Section title="2. Use of Service">
        <SubSection title="2.1 Eligibility">
          <Paragraph>
            You must be at least 13 years old to use this Service. If you are under 18, you must have permission from a parent or guardian. By using the Service, you represent that you meet these requirements.
          </Paragraph>
        </SubSection>

        <SubSection title="2.2 Account Registration">
          <Paragraph>To access certain features, you must register for an account. You agree to:</Paragraph>
          <List items={[
            'Provide accurate, current, and complete information',
            'Maintain the security of your account credentials',
            'Notify us immediately of any unauthorized access',
            'Accept responsibility for all activities under your account'
          ]} />
        </SubSection>

        <SubSection title="2.3 License to Use">
          <Paragraph>
            Subject to these Terms, we grant you a limited, non-exclusive, non-transferable, revocable license to access and use the Service for your personal or business purposes.
          </Paragraph>
        </SubSection>
      </Section>

      {/* Prohibited Activities */}
      <Section title="3. Prohibited Activities">
        <Paragraph>You agree not to:</Paragraph>
        <List items={[
          'Use the Service for any illegal purpose',
          'Attempt to gain unauthorized access to our systems',
          'Interfere with or disrupt the Service or servers',
          'Use automated tools (bots, scrapers) without permission',
          'Reverse engineer or decompile any part of the Service',
          'Impersonate another person or entity',
          'Collect user information without consent',
          'Transmit spam or unsolicited communications'
        ]} />
      </Section>

      {/* Intellectual Property */}
      <Section title="4. Intellectual Property Rights">
        <Paragraph>
          The Service and its original content, features, and functionality are owned by DIZEE and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
        </Paragraph>
        <Paragraph>
          You may not copy, modify, distribute, sell, or lease any part of our Service without our express written permission.
        </Paragraph>
      </Section>

      {/* Disclaimer of Warranties */}
      <Section title="5. Disclaimer of Warranties">
        <div className="p-4 bg-[rgba(255,59,48,0.1)] border border-[rgba(255,59,48,0.3)] rounded mt-4">
          <p className="text-[11px] uppercase font-medium text-white">
            THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED.
          </p>
        </div>
        <Paragraph>We do not warrant that:</Paragraph>
        <List items={[
          'The Service will be uninterrupted, secure, or error-free',
          'The results obtained from the Service will be accurate or reliable',
          'Any errors in the Service will be corrected'
        ]} />
      </Section>

      {/* Limitation of Liability */}
      <Section title="6. Limitation of Liability">
        <div className="p-4 bg-[rgba(255,59,48,0.1)] border border-[rgba(255,59,48,0.3)] rounded mt-4">
          <p className="text-[11px] uppercase font-medium text-white">
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, DIZEE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES.
          </p>
        </div>
        <Paragraph>
          Our total liability to you for all claims arising from or related to the Service shall not exceed the amount you paid us in the 12 months prior to the claim, or $100, whichever is greater.
        </Paragraph>
      </Section>

      {/* Contact Us */}
      <Section title="7. Contact Us">
        <Paragraph>If you have questions about these Terms, please contact us:</Paragraph>
        <div className="mt-4 p-4 bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.1)] rounded">
          <p className="text-[11px]">
            <strong className="text-white">Email:</strong>{' '}
            <a href="mailto:legal@dizee.app" className="text-[#3b82f6] hover:text-[#60a5fa] transition-colors">
              legal@dizee.app
            </a>
          </p>
          <p className="text-[11px] mt-2">
            <strong className="text-white">Address:</strong> [Your Company Address]
          </p>
          <p className="text-[11px] mt-2">
            <strong className="text-white">Phone:</strong> [Your Contact Number]
          </p>
        </div>
      </Section>
    </LegalPageLayout>
  );
};

export default TermsOfService;
